import React from 'react';
import classNames from 'classnames';

import {Page, PageDetails} from '../../../../types';
import styles from './TabMenu.module.scss';
import {useLocation} from 'react-router';
import {Link} from 'react-router-dom';

export interface Props {}

const pages: PageDetails[] = [
  {
    id: Page.Home,
    title: 'Home',
  },
  {
    id: Page.Library,
    title: 'Library',
  },
  {
    id: Page.Browse,
    title: 'Browse',
  },
  {
    id: Page.Feed,
    title: 'Feed',
  },
];

export default function TabMenu() {
  const location = useLocation();

  const tabsMarkup = pages.map(({id, title}) => {
    const contentClassName = classNames(
      styles.Content,
      location.pathname.includes(`/${id}`) && styles.active,
    );

    return (
      <li className={styles.Tab} key={id}>
        <Link to={`/${id}`} style={{textDecoration: 'none'}}>
          <div className={styles.Action}>
            <div className={contentClassName}>{title}</div>
          </div>
        </Link>
      </li>
    );
  });

  return <ol className={styles.TabMenu}>{tabsMarkup}</ol>;
}
